module.exports = __webpack_public_path__ + "/bundle/asset/U2_05-b09848b70d500a68affa15a1b3af400a.gif";